import { FC, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollRestoration: FC = () => {
  const location = useLocation();
  const previousPathRef = useRef(location.pathname);

  useEffect(() => {
    const currentPath = location.pathname;
    const previousPath = previousPathRef.current;

    // Scroll to top ONLY if pathname changed
    if (currentPath !== previousPath) {
      const scrollContainer = document.querySelector('.cl-main');

      !!scrollContainer && scrollContainer.scrollTo({ top: 0 });
    }

    previousPathRef.current = currentPath;
  }, [location]);

  return null;
};
